import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import SplitPane from "react-split-pane";
import UpdateDerivedVariableMeta from "./UpdateDerivedVariableMeta";
import { CiSearch } from "react-icons/ci";
import Swal from "sweetalert2";
import DeletedDerivedVariableMeta from "./DeletedDerivedVariableMeta";
import TableProperties from "../CommonProperties/TableProperties";
import CustomEditCheckActivities from "../CommonProperties/CustomEditCheckActivities";
import CustomEditCheckQuery from "../CommonProperties/CustomEditCheckQuery";
import { useParams } from "react-router-dom";
import UseToggle from "../../../../Hooks/UseToggle";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import AddDerivedVariableMetaForm from "./AddDerivedVariableForm";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import DuplicateDerivedVariableForm from "./DuplicateDerivedVariableForm";
import Pagination from "../../../Pagination";
import RuleTesting from "../CommonProperties/RuleTesting";
import TestCases from "../CommonProperties/TestCases";
import { isHTMLIdentifier } from "../../../../utils/universalFunction";

const DerivedVariableDataList = ({category, onMouseDown, tableRef }) => {
  const [searchData, setSearchData] = useState("");
  const [checkData, setCheckata] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [customEditCheckList, setCustomEditCheckList] = useState([]);
  const [customEditCheckCount, setCustomEditCheckCount] = useState(0);
  const [deletedCustomEditCheck, setDeletedCustomEditCheck] = useState([]);
  const [deletedCustomEditCheckCount, setDeletedCustomEditCheckCount] = useState(0);
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [checkId, setCheckId] = useState("");
  const [testCaseRefreshKey, setTestCaseRefreshKey] = useState(0);
  const [activityLoader, setActivityLoader] = useState(false);
  const [checkActivity, setCheckActivity] = useState([]);
  const [checkActivityCount, setCheckActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDuplicateFormOpen, setIsDuplicateFormOpen] = useState(false);

  const formColumn = [
    { columnLabel: 'Type', columnName: 'TYPE', columnType: 'text' },
    { columnLabel: 'Label', columnName: 'LABEL', columnType: 'text' },
    { columnLabel: 'Schema', columnName: 'SCHEMA', columnType: 'text' },
    { columnLabel: 'Event', columnName: 'EVENT', columnType: 'text' },
    { columnLabel: 'Form', columnName: 'FORM', columnType: 'text' },
    { columnLabel: 'Version', columnName: 'VERSION', columnType: 'number' },
    { columnLabel: 'Field', columnName: 'FIELD', columnType: 'text' },
    { columnLabel: 'Sub Field', columnName: 'SUBFIELD', columnType: 'text' },
  ];

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(customEditCheckCount / itemsPerPage);

  const getStudyLevelDerivedVariable = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelDerivedVariable(
      studyId,
      category,
      "active",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setCustomEditCheckList(data?.data || []);
    setCustomEditCheckCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudyLevelDerivedVariable = async (pageNumberDeleted, itemsPerPageDeleted) => {
    let data = await studyLevelFormManagementServices.getStudyLevelDerivedVariable(
      studyId, category, "deleted", "", pageNumberDeleted, itemsPerPageDeleted
    );
    setDeletedCustomEditCheck(data?.data || []);
    setDeletedCustomEditCheckCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studyLevelCustomEditCheck",
      studyId,
      checkData?.checkId,
      StudyMode,
      pageNumber, itemsPerPage
    );
    setCheckActivity(data?.data || []);
    setCheckActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData("studyLevelCustomEditCheck", studyId);
    setTableColumns(data?.data || {});
  };

  useEffect(() => {
    getTablePropertiesData()
  }, []);

  useEffect(() => {
    if(category){
      getStudyLevelDerivedVariable();
    }
  }, [category, searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreStudyLevelCustomEditCheck = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} this item!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await studyLevelFormManagementServices.softDeleteRestoreStudyLevelCustomEditCheck(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyLevelDerivedVariable();
          setCheckId("")
          if (type === "restore") {
            getDeletedStudyLevelDerivedVariable(pageNumberDeleted, itemsPerPageDeleted);
          }
        }
      }
    });
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.type = "studyLevelCustomEditCheck";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(userData);
        if (data?.statusCode === 200) {
          getStudyLevelDerivedVariable();
          getTablePropertiesData();
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add Derived Verable"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setIsDuplicateFormOpen("")
              setCheckId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {customEditCheckCount > 0 &&
            <>
              <i
                title={isDuplicateFormOpen ? "Close Duplicate Form" : "Duplicate Derived Verable"}
                onClick={() => {
                  setIsDuplicateFormOpen(!isDuplicateFormOpen);
                  setIsFormOpen("");
                  setCheckId("");
                }}
                className={`fa-solid ${isDuplicateFormOpen ? "fa-table-list" : "fa-clone CP"
                  }`}
              />
              <div className="vr"></div>
              <div className="position-relative">
                <Form.Control
                  type="Search"
                  onChange={(e) => setSearchData(e.target.value)}
                  value={searchData}
                  disabled={customEditCheckCount === 0}
                  placeholder="Search..."
                  style={{ width: 200, padding: "3px 10px" }}
                ></Form.Control>
                <CiSearch
                  className="CP position-absolute bg-white"
                  title="Search"
                  style={{ width: 15, top: 4, right: 7 }}
                />
              </div>
            </>
          }
        </div>
        <div className="hstack gap-2">
          {customEditCheckCount > 0 && (
            <button
              onClick={() => {
                setToggle2();
                getTablePropertiesData()
              }}
              className={`updateProfile`}
            >
              Table Properties
            </button>
          )}
          {deletedCustomEditCheckCount > 0 && (
            <button
              onClick={() => {
                setToggle1();
                getDeletedStudyLevelDerivedVariable(pageNumberDeleted, itemsPerPageDeleted);
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={checkId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={(isFormOpen || isDuplicateFormOpen) ? "20%" : "100%"}
        >
          {isFormOpen ? (
            <AddDerivedVariableMetaForm category={category} getStudyLevelDerivedVariable={getStudyLevelDerivedVariable} />
          ) : isDuplicateFormOpen && <DuplicateDerivedVariableForm category={category} />}
          {loading ? (
            <PageLoader />
          ) : customEditCheckCount === 0 ? (
            <NoDataFoundTable MSG={category === "derived" ? "Derived variable list not found!" : "Assigned based factor list not found!"} />
          ) : customEditCheckList?.length === 0 ? (
            <NoDataFoundTable MSG={category === "derived" ? "Search Derived variable list not found!" : "Search Assigned based factor list not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    {!tableColumns["TYPE"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>Type</th>
                    }
                    {!tableColumns["LABEL"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>Label</th>
                    }
                    {!tableColumns["SCHEMA"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>Schema</th>
                    }
                    {!tableColumns["EVENT"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 5)}>Event</th>
                    }
                    {!tableColumns["FORM"] &&
                      <th style={{ width: 200 }} onMouseDown={(e) => onMouseDown(e, 6)}>Form</th>
                    }
                    {!tableColumns["VERSION"] &&
                      <th style={{ width: 80 }} onMouseDown={(e) => onMouseDown(e, 7)}>Version</th>
                    }
                    {!tableColumns["FIELD"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 8)}>Field</th>
                    }
                    {!tableColumns["SUBFIELD"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 9)}>Sub Field</th>
                    }
                    <th
                      onMouseDown={(e) => onMouseDown(e, 10)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 11)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {customEditCheckList?.map((checkData, index) => (
                    <tr
                      key={index}
                      className={`CP ${checkId === checkData?._id ? "highlighted" : ""}`}
                      onClick={() => { setIsFormOpen(false); setIsDuplicateFormOpen(false) }}
                      title="View Details"
                    >
                      <td
                        onClick={() => {
                          setCheckata(checkData);
                          setCheckId(checkData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      {!tableColumns["TYPE"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.type === "byEvent" ? "By Event" : "Global"}
                        </td>}
                      {!tableColumns["LABEL"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.label}
                        </td>}
                      {!tableColumns["SCHEMA"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.schemaName}
                        </td>}
                      {!tableColumns["EVENT"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.eventName} {checkData?.timePointId && `(${checkData?.timePointLabel})`}
                        </td>}
                      {!tableColumns["FORM"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.formName} ({checkData?.formCode})
                        </td>}
                      {!tableColumns["VERSION"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.version}
                        </td>}
                      {!tableColumns["FIELD"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {isHTMLIdentifier(checkData?.mainFieldName || "") ? (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: checkData?.mainFieldName,
                              }}
                            />
                          ) : (
                            checkData?.mainFieldName
                          )} ({checkData?.mainFieldCode})
                        </td>}
                      {!tableColumns["SUBFIELD"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {isHTMLIdentifier(checkData?.fieldName || "") ? (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: checkData?.fieldName,
                              }}
                            />
                          ) : (
                            checkData?.fieldName
                          )} ({checkData?.fieldCode})
                        </td>}
                      {(
                        <>
                          <td className="text-center" onClick={() => {
                            setCheckata(checkData);
                            setToggle();
                          }} title={`Update ${checkData?.label}`} >
                            <FaEdit
                              className="text-muted"
                            />
                          </td>
                          <td className="text-center" title={`Delete ${checkData?.label}`} onClick={() =>
                            softDeleteRestoreStudyLevelCustomEditCheck(checkData?._id, "delete")
                          }>
                            <FaTrash
                              className="text-danger"
                            />
                          </td>
                        </>
                      )}
                    </tr>

                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={customEditCheckCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {checkId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {[
                  "activities",
                  "derived Variable",
                  "Rule Testing",
                  "test Cases",
                ].map((tab) => (
                  <button
                    key={tab}
                    className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                      }`}
                    onClick={() => setActiveTab(tab)}
                    title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setCheckId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <CustomEditCheckActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                checkActivity={checkActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                checkData={checkData}
                checkActivityCount={checkActivityCount}
              />
            )}
            {activeTab === "derived Variable" && (
              <CustomEditCheckQuery
                checkData={checkData}
                getStudyLevelCustomEditCheck={getStudyLevelDerivedVariable}
                miniOperator
              />
            )}
            {activeTab === "Rule Testing" && (
              <RuleTesting
                checkData={checkData}
                category={category}
                onTestCaseSaved={() => setTestCaseRefreshKey((key) => key + 1)}
              />
            )}
            {activeTab === "test Cases" && (
              <TestCases checkData={checkData} refreshKey={testCaseRefreshKey} />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateDerivedVariableMeta
        Show={!toggle}
        Hide={setToggle}
        checkData={checkData}
        setCheckata={setCheckata}
        setCheckId={setCheckId}
        category={category}
        getStudyLevelDerivedVariable={getStudyLevelDerivedVariable}
        Title={"Update Derived Variable Meta"}
      />
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <DeletedDerivedVariableMeta
        Show={!toggle1}
        Hide={setToggle1}
        setCheckId={setCheckId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        category={category}
        deletedCustomEditCheck={deletedCustomEditCheck}
        getDeletedStudyLevelDerivedVariable={getDeletedStudyLevelDerivedVariable}
        deletedCustomEditCheckCount={deletedCustomEditCheckCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudyLevelCustomEditCheck={softDeleteRestoreStudyLevelCustomEditCheck}
        Title={"Deleted Derived Variable Meta History"}
      />
    </>
  );
};

export default DerivedVariableDataList;
